import { Component, Input } from "@angular/core";

@Component({
    selector: "zbd-info",
    templateUrl: "info.component.html",
    styles: [
        `
            .info-action {
                margin-top: 4px;
                margin-bottom: 8px;
            }
            .zas-info-directive {
                width: 24px;
            }
        `,
    ],
})
export class InfoComponent {}
